import { render, staticRenderFns } from "./HeaderRegion.vue?vue&type=template&id=972d93c0&scoped=true&"
import script from "./HeaderRegion.vue?vue&type=script&lang=js&"
export * from "./HeaderRegion.vue?vue&type=script&lang=js&"
import style0 from "./HeaderRegion.vue?vue&type=style&index=0&id=972d93c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972d93c0",
  null
  
)

export default component.exports